// Renders the inlined static Vega v5 scatter spec (Trends::ScatterSpec) —
// the raw Vega runtime, no vega-embed/vega-lite, roughly halving the public
// bundle. The spec ships in a <script type="application/json"> inside the
// container, so there is no fetch and no crawlable data endpoint.
// Vega is import()ed inside the mount (same pattern as trends_map): the
// runtime lives in a split chunk that only loads when a scatter approaches
// the viewport, keeping it out of the initial public.js parse.
import { whenVisible } from "./lazy"
import { createTip } from "./tooltip"

export function initTrendsScatters() {
  document.querySelectorAll("[data-trends-scatter]").forEach((el) => {
    whenVisible(el, () => mountScatter(el).catch(() => {}))
  })
}

async function mountScatter(el) {
  const vega = await import("vega")
  const script = el.querySelector("script[type='application/json']")
  if (!script) return

  const spec = JSON.parse(script.textContent)
  // The container carries an aspect-ratio class; size the view to it so the
  // reserved space is exactly filled (zero layout shift).
  spec.width = el.clientWidth || spec.width
  spec.height = el.clientHeight || spec.height

  // The store map's pill instead of Vega's default handler — that one is the
  // browser-native title tooltip, gray and shown only after the OS delay.
  // The tip must attach AFTER initialize(el): vega empties the container.
  el.style.position = "relative"
  let tip = null
  const tooltip = (view, event, item, value) => {
    if (!tip) return
    if (value == null || value === "") {
      tip.hide()
      return
    }
    const rect = el.getBoundingClientRect()
    tip.show(event.clientX - rect.left, event.clientY - rect.top, String(value))
  }

  new vega.View(vega.parse(spec), { renderer: "svg", tooltip })
    .initialize(el)
    .hover()
    .runAsync()
  tip = createTip(el)
}
